"use strict";

/* eslint-disable no-param-reassign */
var _ = require('lodash');
var moment = require('moment');
module.exports = /*@ngInject*/function ($timeout, $scope, Analytics, ConfigService, PreferenceService, ProfileService, ReportService, uniqGroups, uniqTags) {
  var ctrl = this;
  // eslint-disable-next-line radix
  ctrl.pageLimit = parseInt(ConfigService.getConfig().REPORT_PAGE_SIZE);
  ctrl.status = ReportService.calculateStatusBasedOnRole();
  ctrl.findingStatusList = ['Compliant', 'Corrected On Site', 'In Progress', 'NA', 'NOT_OBSERVED', 'No Further Action', 'Not Resolved', 'Ready For Verification', 'Resolved'];
  ctrl.today = new Date();
  ctrl.threeMonthsAgo = new Date(new Date(ctrl.today).setMonth(ctrl.today.getMonth() - 3));
  ctrl.uniqGroups = _.sortBy(uniqGroups);
  ctrl.uniqTags = _.sortBy(uniqTags);
  ctrl.reports = [];
  ctrl.profile = ProfileService.getProfile();
  ctrl.opened = {};
  ctrl.dateFormats = ['yyyy-MM-dd', 'MM/dd/yyyy', 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
  ctrl.totalReports = 0;
  ctrl.showMessage = false;
  ctrl.open = function (item) {
    ctrl.opened[item] = true;
  };
  ctrl.onAdvancedSearch = function () {
    ctrl.query.isAdvancedSearch = true;
    ctrl.query.name = undefined;
  };
  ctrl.searchCancel = function () {
    ctrl.query.isAdvancedSearch = false;
    ctrl.query = _.pick(ctrl.query, ['name', 'beginDate', 'endDate', 'status']);
  };
  ctrl.getResults = function (query, array) {
    return _.filter(array, function (result) {
      return result.toLowerCase().indexOf(query.toLowerCase()) > -1;
    });
  };
  ctrl.init = function () {
    ctrl.initSearch();
  };
  ctrl.initSearch = function () {
    ctrl.query = Object.keys(PreferenceService.get().reportsQuery || {}).length === 0 ?
    // eslint-disable-next-line prefer-object-spread
    Object.assign({}, ReportService.reportQuery, {
      status: ReportService.reportQuery.status.filter(function (status) {
        return status !== 'Done';
      })
    }) : PreferenceService.get().reportsQuery;
    ctrl.query.offSet = 0;
    ctrl.query.tags = ctrl.stringToArray(ctrl.query.tags);
    ctrl.query.routingGroups = ctrl.stringToArray(ctrl.query.routingGroups);
    ctrl.query.findingStatus = ctrl.stringToArray(ctrl.query.findingStatus);
    ctrl.query.status = ctrl.stringToArray(ctrl.query.status);
    if (ctrl.query.beginDate) {
      ctrl.query.beginDate = new Date(ctrl.query.beginDate);
    } else {
      ctrl.query.beginDate = ctrl.threeMonthsAgo;
    }
    if (ctrl.query.endDate) {
      ctrl.query.endDate = new Date(ctrl.query.endDate);
    }
    ctrl.executeQuery(ctrl.query);
  };
  ctrl.onChangeHandler = function (query) {
    query.offSet = 0;
    ctrl.reports = [];
    if (!query.status.length) {
      query.status = ReportService.calculateStatusBasedOnRole();
    }
    ctrl.executeQuery(query);
  };
  ctrl.executeQuery = function (query) {
    var clonedQuery = _.cloneDeep(query);
    if (clonedQuery.beginDate) {
      clonedQuery.beginDate = ctrl.setDate(clonedQuery.beginDate);
    } else {
      delete clonedQuery.beginDate;
    }
    if (clonedQuery.endDate) {
      clonedQuery.endDate = ctrl.setDate(clonedQuery.endDate);
    } else {
      delete clonedQuery.endDate;
    }
    ctrl.progress = true;
    ReportService.listReports({}, clonedQuery, function (result) {
      ctrl.totalReports = result.metadata.length ? result.metadata[0].count : 0;
      ctrl.progress = false;
      ctrl.reports = clonedQuery.offSet === 0 ? result.reports : ctrl.reports.concat(result.reports);
      ctrl.query.offSet = clonedQuery.offSet + ctrl.pageLimit;
    });
  };
  ctrl.cacheQuery = function (query) {
    ctrl.showMessage = false;
    var preferenceQuery = _.cloneDeep(query);
    PreferenceService.save('reportsQuery', preferenceQuery);
    ctrl.message = 'Search saved successfully!';
    ctrl.showMessage = true;
  };
  ctrl.useDefaultQuery = function () {
    PreferenceService.save('reportsQuery', {});
    ctrl.initSearch();
  };
  ctrl.actionConfirmationClose = function () {
    ctrl.showMessage = false;
    ctrl.message = '';
  };
  ctrl.stringToArray = function (val) {
    return typeof val === 'string' ? [val] : val;
  };
  ctrl.setDate = function (date) {
    return moment(date, 'x').startOf('day').toDate().valueOf();
  };
  ctrl.init();
};